import { Input } from 'antd';
import React, { ChangeEvent, FC } from 'react';
import Required from '../required/Required';
import style from './index.module.scss';

type TProps = {
  onTitleChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  title?: string;
  label?: string;
  isTextarea?: boolean;
  placeholder?: string;
};

const RequredField: FC<TProps> = ({ onTitleChange, title, placeholder, label = 'Заголовок', isTextarea = false }) => {
  return (
    <div className={style.title}>
      <h3>
        <Required>{label}</Required>
      </h3>
      {isTextarea ? (
        <Input.TextArea onChange={onTitleChange} value={title} rows={4} placeholder={placeholder} />
      ) : (
        <Input onChange={onTitleChange} value={title} />
      )}
    </div>
  );
};

export default RequredField;
